// 门锁管理
const distributionRoomManageJurisdiction = [
  { id: '056002001', label: '添加', children: [] },
  { id: '056002002', label: '修改', children: [] },
  { id: '056002003', label: '删除', children: [] }
]

// 权限管理
const environmentGatewayManageJurisdiction = [
  { id: '056003001', label: '添加', children: [] },
  { id: '056003002', label: '修改', children: [] },
  { id: '056003003', label: '删除', children: [] }
]

// 电压采集网关
// const voltageGatewayManageJurisdiction = [
//   { id: '033004001', label: '添加', children: [] },
//   { id: '033004002', label: '修改', children: [] },
//   { id: '033004003', label: '删除', children: [] }
// ]

// 配电柜
// const distributionCabinetManageJurisdiction = [
//   { id: '033005001', label: '添加', children: [] },
//   { id: '033005002', label: '修改', children: [] },
//   { id: '033005003', label: '删除', children: [] }
// ]

// 阈值配置
// const smartDetectionAlarmJurisdiction = [
//   { id: '033008001', label: '修改', children: [] }
// ]

// 报警记录
// const smartDetectionAlarmRecordJurisdiction = [
//   { id: '033009001', label: '添加', children: [] }
// ]

// 设备状态日志
// const smartDetectionDeviceStateJurisdiction = [
//   { id: '033010001', label: '导出', children: [] }
// ]
// 集中器管理
const concentratorManagementJurisdiction = [
  { id: '056001001', label: '添加', children: [] },
  { id: '056001002', label: '修改', children: [] },
  { id: '056001003', label: '删除', children: [] }
]

// 配电监测
const smartDoorLockJurisdictionChildren = [
  {
    id: '056001000',
    label: '集中器管理',
    routerName: 'lock-concentrator-manage',
    children: concentratorManagementJurisdiction
  },
  {
    id: '056002000',
    label: '门锁管理',
    routerName: 'lock-gate-manage',
    children: distributionRoomManageJurisdiction
  },
  {
    id: '056003000',
    label: '权限管理',
    routerName: 'lock-authorization-manage',
    children: environmentGatewayManageJurisdiction
  },
  {
    id: '056004000',
    label: '授权记录',
    routerName: 'lock-authorization-record',
    children: []
  },
  {
    id: '056005000',
    label: '识别记录',
    routerName: 'lock-identification-record',
    children: []
  },
  // {
  //   id: '033006000',
  //   label: '环境监测',
  //   routerName: 'smart-detection-environmental-monitoring',
  //   children: []
  // },
  // {
  //   id: '033007000',
  //   label: '运行监测',
  //   routerName: 'smart-detection-operation-monitoring',
  //   children: []
  // },
  // {
  //   id: '033008000',
  //   label: '阈值配置',
  //   routerName: 'smart-detection-alarm',
  //   children: smartDetectionAlarmJurisdiction
  // },
  // {
  //   id: '033009000',
  //   label: '报警记录',
  //   routerName: 'smart-detection-alarm-record',
  //   children: smartDetectionAlarmRecordJurisdiction
  // },
  // {
  //   id: '033010000',
  //   label: '设备状态日志',
  //   routerName: 'smart-detection-device-state',
  //   children: smartDetectionDeviceStateJurisdiction
  // },
  {
    id: '056006000',
    label: '操作日志',
    routerName: 'lock-log',
    children: []
  }
]

const smartDoorLockJurisdiction = {
  id: '056',
  label: '智慧门锁',
  children: smartDoorLockJurisdictionChildren
}

export { smartDoorLockJurisdiction }



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/smartDoorLockJurisdiction.js